export default __webpack_public_path__ + "static/media/bg01.e8239183.jpg";